export default __webpack_public_path__ + "static/Ambient365Logo-black-b19dd12abbbc8a0db2ceddf654120a89.png";